import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.memberVisits.dataPoints);

  if (!dataPoints || !dataPoints.length) return null;

  return (
    <div className="section">
      <div className="data-points">
        {dataPoints.map((dataPoint, idx) => (
          <div key={`${idx}-row`} className="data-point ">
            <DataDisplay
              key={dataPoint.label}
              label={dataPoint.label}
              value={dataPoint.value}
              url={dataPoint.url}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default DataPoints;
